"use client";

import { useSearchParams } from "next/navigation";
import React, { useEffect, useState } from "react";
import articelApi from "@/service/modules/articelApi";
import { base64Decode } from "@/utils/getArticleContent";
import { Image } from "antd";
import TabBar from "@/components/TabBar";

interface Props {
  articleName: string;
  banner?: string;
  backTopClassName?: string;
}

export default function ArticleTemplate({
  articleName,
  banner,
  backTopClassName,
}: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const [tabList, setTabList] = useState<any[]>([]);

  const searchParams = useSearchParams();

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  // 获取文章
  useEffect(() => {
    if (!articleName) return;

    const fetchArticle = async () => {
      try {
        const data: any = await articelApi.getArticleContent(articleName);

        const { article } = data.data;

        const newTabList =
          article?.map((item: any, index: number) => ({
            ...item,
            name: item.title,
            id: index,
            content: base64Decode(item.content),
          })) || [];

        setTabList(newTabList);
      } catch (e) {
        console.error(e);
      }
    };

    fetchArticle();
  }, [articleName]);

  useEffect(() => {
    const activeTab = searchParams.get("activeTab");

    console.log(activeTab);
    if (activeTab) {
      // 判断参数是否合规，合规参数才进行tab赋值
      const target = tabList.filter(
        (_, index: number) => index == Number(activeTab),
      );

      if (target.length) handleTabChange(Number(activeTab));
    }
  }, [searchParams]);

  // 回到顶部
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 添加平滑滚动效果
    });
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      backTopClassName || "[class*='back-top']",
    );

    elements.forEach((el) => el.addEventListener("click", backToTop));

    return () => {
      elements.forEach((el) => el.removeEventListener("click", backToTop));
    };
  }, [tabList]);

  return (
    <div className="article-page">
      {banner && (
        <Image
          className="article-banner"
          src={banner}
          alt="article"
          width="100%"
          height="auto"
          preview={false}
        />
      )}

      {tabList.length > 1 && (
        <TabBar
          tabList={tabList}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}
      <div
        dangerouslySetInnerHTML={{ __html: tabList[activeTab]?.content || "" }}
      ></div>
    </div>
  );
}
